import React from 'react';

const ProfileIcon = (props: object) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      {...props}
    >
      <path
        d="M12.7988 21C17.7694 21 21.7988 16.9706 21.7988 12C21.7988 7.02944 17.7694 3 12.7988 3C7.82827 3 3.79883 7.02944 3.79883 12C3.79883 16.9706 7.82827 21 12.7988 21Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.7988 15C14.8699 15 16.5488 13.3211 16.5488 11.25C16.5488 9.17893 14.8699 7.5 12.7988 7.5C10.7278 7.5 9.04883 9.17893 9.04883 11.25C9.04883 13.3211 10.7278 15 12.7988 15Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.7793 18.6904C7.34359 17.5789 8.20463 16.6454 9.26699 15.9933C10.3294 15.3413 11.5515 14.9961 12.798 14.9961C14.0446 14.9961 15.2667 15.3413 16.3291 15.9933C17.3915 16.6454 18.2525 17.5789 18.8168 18.6904"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ProfileIcon;
